
<div class="s3">
  <div v-if="!value">
    <div v-if="status === 'preupload'">
      <span class="text">送信準備中...</span>
    </div>
    <div v-else-if="status === 'uploading'" class="ui indicating progress" data-percent="0">
      <div class="bar"></div>
      <div class="label">{{ progress }}%</div>
    </div>
    <input v-else type="file" :accept="accept" @change="attach($event.target)" />
  </div>
  <div v-else>
    <span v-if="value && value.mime_type && value.mime_type === 'application/pdf'" class="pdfIcon">
      <i class="fas fa-file-pdf"></i>
    </span>
    <img v-else-if="value && value.urls.preview" :src="value.urls.preview">
    <img v-else-if="value && value.urls.small" :src="value.urls.small">
    <span class="filename" :title="value.original_file_name">{{ value.original_file_name }}</span>
    <button class="ui mini negative button" type="button" @click="clear()">削除</button>
  </div>
</div>
